import { Sort } from '@spike/model';
import { TableHeader } from 'components/UI/V3/Table/Header/TableHeader';
import { FunctionComponent } from 'react';
import HeaderTableColumn from './HeaderTableColumn';
import { appointmentSortColumns } from './groomingSort';

interface EvaluationHeaderTableProps {
    sort: Sort | null;
    onSort?: (sort: Sort) => void;
}

export const EvaluationHeaderTable: FunctionComponent<EvaluationHeaderTableProps> = props => {
    return (
        <TableHeader>
            <HeaderTableColumn
                sortColumn={appointmentSortColumns.client}
                selectedSort={props.sort}
                onServerSort={props.onSort}
            >
                Client Name
            </HeaderTableColumn>
            <HeaderTableColumn
                sortColumn={appointmentSortColumns.pet}
                selectedSort={props.sort}
                onServerSort={props.onSort}
            >
                Pet Name
            </HeaderTableColumn>
            <HeaderTableColumn
                sortColumn={appointmentSortColumns.service}
                selectedSort={props.sort}
                onServerSort={props.onSort}
            >
                Service
            </HeaderTableColumn>
            <HeaderTableColumn
                sortColumn={appointmentSortColumns.bookedAt}
                selectedSort={props.sort}
                onServerSort={props.onSort}
            >
                Date & Time
            </HeaderTableColumn>
            <HeaderTableColumn
                sortColumn={appointmentSortColumns.total}
                selectedSort={props.sort}
                onServerSort={props.onSort}
            >
                Total
            </HeaderTableColumn>
            <HeaderTableColumn
                sortColumn={appointmentSortColumns.status}
                selectedSort={props.sort}
                onServerSort={props.onSort}
            >
                Status
            </HeaderTableColumn>
        </TableHeader>
    );
};

export default EvaluationHeaderTable;
